// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"spinner_loadingOverlay__h-NYX","spinner":"spinner_spinner__o5kOv","spin":"spinner_spin__n0xzv"};